export default __webpack_public_path__ + "static/media/img1.20442733.png";